module.exports = __webpack_public_path__ + "img/two.94d2c34a.jpg";